import { Directive, effect, inject, input, InputSignalWithTransform } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ANALYTICS_EVENT_SOURCE } from '../tokens';
import { AnalyticsEventSourceContext, AnalyticsEventSourceInput } from './analytics-event-source-context';

@Directive({
  selector: '[luAnalyticsEventSource]',
  providers: [
    {
      provide: ANALYTICS_EVENT_SOURCE,
      useFactory: (): BehaviorSubject<string> => new BehaviorSubject<string>(''),
    },
  ],
})
export class AnalyticsEventSourceDirective {
  public readonly luAnalyticsEventSource: InputSignalWithTransform<
    AnalyticsEventSourceContext<string>,
    AnalyticsEventSourceInput
  > = input<AnalyticsEventSourceContext<string>, AnalyticsEventSourceInput>(
    { source: '' },
    {
      transform: resolveAnalyticsEventSource,
    }
  );

  private readonly source: BehaviorSubject<string> = inject(ANALYTICS_EVENT_SOURCE);

  constructor() {
    effect(() => {
      this.source.next(this.luAnalyticsEventSource().source);
    });
  }
}

function resolveAnalyticsEventSource(value: AnalyticsEventSourceInput): AnalyticsEventSourceContext<string> {
  if (typeof value === 'string' || Array.isArray(value)) {
    return { source: serializeSource(value) };
  }

  return {
    ...value,
    source: serializeSource(value.source),
  };
}

function serializeSource(value: string | string[]): string {
  return Array.isArray(value) ? value.join(' | ') : value;
}
